module.exports = __webpack_public_path__ + "img/pause.a25a3ba3.svg";